/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {supplyCheckRecipientContacts} from '../api'

export const useMutationSupplyCheckRecipientContacts = createReactQueryMutationHook('supplyCheckRecipientContacts', supplyCheckRecipientContacts)
